import { useHelmet } from '@thd-nucleus/thd-helmet';
import { generateTags } from '../../utils/generate-tags';
import { HD_URL } from '../../constants';
import { getStoreDirectoryBreadcrumbs } from './store-directory-helpers';

// --- Tag Handler ---

const storeDirectoryHandler = () => {

  const schemas = [{
    content: getStoreDirectoryBreadcrumbs(),
    id: 'storeDirectoryStructuredDataBreadcrumb'
  }];

  const tags = generateTags({
    canonical: `${HD_URL}/l/storeDirectory`,
    description: 'Find the Home Depot stores near you on our store directory. '
      + 'Get directions, store hours, and services available at locations nationwide.',
    schemas,
    title: 'The Home Depot Store Directory'
  });

  return tags;
};

// --- Main Component ---

const StoreDirectoryMetadata = () => {
  useHelmet('storeDirectoryMetadata', {}, storeDirectoryHandler, []);
  return null;
};

// --- Component Static Properties (dataModel, propTypes, etc.) ---

StoreDirectoryMetadata.displayName = 'StoreDirectoryMetadata';

StoreDirectoryMetadata.propTypes = {};

StoreDirectoryMetadata.defaultProps = {};

export { StoreDirectoryMetadata };